
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./makanapp/pages/Landing";
import Home from "./makanapp/pages/Home";
import Contact from "./makanapp/pages/Contact";
import NoPage from "./makanapp/pages/NoPage";
import Blogs from "./makanapp/pages/Blogs";
import Login from "./makanapp/pages/Login";
import LoginNewAcct from "./makanapp/pages/LoginNewAcct";
import Halal from "./makanapp/pages/category/Halal";
import Chinese from "./makanapp/pages/category/Chinese";
import Indian from "./makanapp/pages/category/Indian";
import Western from "./makanapp/pages/category/Western";
import SignUp from "./makanapp/pages/SignUp";
import LoginVerifiedAcct from "./makanapp/pages/LoginVerifiedAcct";
import Dashboard from "./makanapp/pages/Dashboard";
import PrivateResource from "./makanapp/pages/PrivateResource";
import PublicResource from "./makanapp/pages/PublicResource";
import Delivery from "./makanapp/pages/Delivery";
import JobDetails from "./makanapp/pages/JobDetails";
import CreateOrder from "./makanapp/pages/CreateOrder";
import Signout from "./makanapp/pages/Signout";


function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />}>
          <Route index element={<Home />} /> 
          <Route path="signup" element={<SignUp />} />
          <Route path="signin" element={<Login />} />
          <Route path="signout" element={<Signout />} />
          <Route path="verifiedsignin" element={<LoginVerifiedAcct />} />
          <Route path="newsignin" element={<LoginNewAcct />} />
          <Route path="contact" element={<Contact />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="blogs" element={<Blogs />} />
          <Route path="*" element={<NoPage />} /> 
          <Route path="privateresource" element={<PrivateResource />} />
          <Route path="createorder" element={<CreateOrder />} />
          <Route path="delivery" element={<Delivery />} />
          <Route path="jobdetails" element={<JobDetails />} />
          <Route path="publicresource" element={<PublicResource />} />
          <Route path="cuisine/halal" element={<Halal />} />
          <Route path="cuisine/chinese" element={<Chinese />} />
          <Route path="cuisine/indian" element={<Indian />} />
          <Route path="cuisine/western" element={<Western />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
